import { render, staticRenderFns } from "./AddVillage.vue?vue&type=template&id=63ce7c74&scoped=true"
import script from "./AddVillage.vue?vue&type=script&lang=js"
export * from "./AddVillage.vue?vue&type=script&lang=js"
import style0 from "./AddVillage.vue?vue&type=style&index=0&id=63ce7c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce7c74",
  null
  
)

export default component.exports